"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DataCellTypeDAP2 = exports.DataCellTypeEnum = void 0;
var DataCellTypeEnum;
(function (DataCellTypeEnum) {
    DataCellTypeEnum[DataCellTypeEnum["Text"] = 0] = "Text";
    DataCellTypeEnum[DataCellTypeEnum["Integer"] = 1] = "Integer";
    DataCellTypeEnum[DataCellTypeEnum["Double"] = 2] = "Double";
    DataCellTypeEnum[DataCellTypeEnum["Boolean"] = 3] = "Boolean";
    DataCellTypeEnum[DataCellTypeEnum["DateTime"] = 4] = "DateTime";
    DataCellTypeEnum[DataCellTypeEnum["Options"] = 5] = "Options";
    DataCellTypeEnum[DataCellTypeEnum["TimeSpan"] = 6] = "TimeSpan";
    DataCellTypeEnum[DataCellTypeEnum["MultiText"] = 7] = "MultiText";
    DataCellTypeEnum[DataCellTypeEnum["Money"] = 8] = "Money";
    DataCellTypeEnum[DataCellTypeEnum["CustomFields"] = 9] = "CustomFields";
    DataCellTypeEnum[DataCellTypeEnum["SSN"] = 10] = "SSN";
    DataCellTypeEnum[DataCellTypeEnum["Link"] = 11] = "Link";
    DataCellTypeEnum[DataCellTypeEnum["Percent"] = 13] = "Percent";
})(DataCellTypeEnum || (exports.DataCellTypeEnum = DataCellTypeEnum = {}));
var DataCellTypeDAP2;
(function (DataCellTypeDAP2) {
    DataCellTypeDAP2["Text"] = "Text";
    DataCellTypeDAP2["Integer"] = "Integer";
    DataCellTypeDAP2["Double"] = "Double";
    DataCellTypeDAP2["Boolean"] = "Boolean";
    DataCellTypeDAP2["DateTime"] = "DateTime";
    DataCellTypeDAP2["Options"] = "Options";
    DataCellTypeDAP2["TimeSpan"] = "TimeSpan";
    DataCellTypeDAP2["MultiText"] = "MultiText";
    DataCellTypeDAP2["Money"] = "Money";
    DataCellTypeDAP2["CustomFields"] = "CustomFields";
    DataCellTypeDAP2["SSN"] = "SSN";
    DataCellTypeDAP2["Link"] = "Link";
    DataCellTypeDAP2["Percent"] = "Percent";
})(DataCellTypeDAP2 || (exports.DataCellTypeDAP2 = DataCellTypeDAP2 = {}));
//# sourceMappingURL=types.js.map